export const INTERNAL_CMS_MEDIA_COLLECTION = 'internal-cms-media';

export const INTERNAL_CMS_MEDIA_FOLDER = 'landings/_internal-cms-media';
